import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../features/auth/auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.html',
})
export class Navbar {
  username = signal('Admin');

  constructor(private auth: AuthService, private router: Router) {}

  logout() {
    this.auth.logout(); // limpia sesión y navega al login
    this.username.set(''); // opcional: limpiar nombre mostrado
  }

  goToProfile() {
    this.router.navigate(['/perfil/datos-personales']);
  }
}
